import store from '../../store/index';
import common from './common';
import {GetRefreshToken} from '@/api/common/common';
import Utils from "@/assets/js/Utils";
let onlineTimer=null;
/**统计在线时间 */
export function watchOnlineTime(){
     socketMsg({ 'sp_account_online_listener': 'sp_account_online_listener' }, true, 'sp_account_online_listener', ['zdzx-sp']);
     onlineTimer = setInterval(() => {
          socketMsg({ 'sp_account_online_listener': 'sp_account_online_listener' }, true, 'sp_account_online_listener', ['zdzx-sp']);
     }, 300000)
};
export function setupWebSocket(callback) {
    let flag=false;
    let ws=null;
    store.commit('changeSocket',{label:'connect',value:true});
    function initSocket(){
        try{
            var ip=process.env.VUE_APP_SERVER_IP+"/socket";
            var token=common.getCookie('token')||'';
            if(!token){
                return;
            }
            var url=ip+`/websocket/${token}`;
            ws = new WebSocket(url);
            store.commit('changeSocket',{label:'ws',value:ws});
        // 连接打开时的回调
            ws.onopen = function() {
                console.log('WebSocket 连接已打开');
                watchOnlineTime();
                socketMsg({appCode:process.env.VUE_APP_APP_CODE},true,'USER_ONLINE_LISTENER',['zdzx-iam']);
                heartCheck.reset().start();
                typeof callback=='function'&&callback();
                };
            // 收到服务器消息时的回调
            ws.onmessage = function(event) {
                var data=JSON.parse(event.data);
                if(data.heartbeat=='heartbeat'){
                    socketMsg({appCode:process.env.VUE_APP_APP_CODE},true,'USER_ONLINE_LISTENER',['zdzx-iam']);
                }
                if(data.callbackFlag){
                    Utils.$emit(data.callbackFlag,data);
                }
                heartCheck.reset().start();
                if(data.refreshToken==='refreshToken'&&!store.state.common.isRefreshing){
                    store.commit('common/changeRefresh',true);
                    var refreshToken=common.getCookie('refreshToken')||'';
                    refreshToken&&GetRefreshToken({refreshToken}).then(res=>{
                        if(res.code===200){
                            store.commit('addUserData',res.data);
                            store.state.common.requests.forEach(cb => cb());
                            store.commit('common/clearRequest');
                        }else{
                            store.commit('common/clearRequest');
                        }
                        store.commit('common/changeRefresh',false);
                    }).catch(err=>{
                        store.commit('common/clearRequest');
                        store.commit('common/changeRefresh',false);
                    })
                }
                console.log('收到服务器消息: ', data);
            };

            // 连接关闭时的回调
            ws.onclose = function() {
                console.log('WebSocket 连接已关闭');
                /**清空在线监测的定时器 */
                onlineTimer&&clearInterval(onlineTimer);
                var connect=store.state.user.socketTimer.connect;
                connect&&reconnectWebSocket(); // 尝试重新连接
            };

            // 处理错误的回调
            ws.onerror = function(error) {
                console.error('WebSocket 出错: ', error);
                /**清空在线监测的定时器 */
                onlineTimer&&clearInterval(onlineTimer);
                var connect=store.state.user.socketTimer.connect;
                connect&&reconnectWebSocket();
            };
        }catch(err){
            console.log(err)
        }
    }
    initSocket();
      //心跳检测
      var heartCheck = {
        timeout: 10*60000,
        timeoutObj: null,
        serverTimeoutObj: null,
        reset: function() {
            this.timeoutObj&&clearTimeout(this.timeoutObj);
            this.serverTimeoutObj&&clearTimeout(this.serverTimeoutObj);
            store.commit('clearTimer');
            return this;
        },
        start: function() {
            var self = this;
            this.timeoutObj = setTimeout(function() {
                //这里发送一个心跳，后端收到后，返回一个心跳消息，
                //onmessage拿到返回的心跳就说明连接正常
                socketMsg('heart',false);
                //如果超过一定时间还没重置，说明后端主动断开了
                self.serverTimeoutObj = setTimeout(function() {
                  //如果onclose会执行reconnect，我们执行ws.close()就行了.
                  //如果直接执行reconnect 会触发onclose导致重连两次
                ws.close(); 
                }, self.timeout)
            }, this.timeout)
            store.commit('changeSocket',{label:'timer1',value:this.timeoutObj});
            store.commit('changeSocket',{label:'timer2',value:this.serverTimeoutObj});
        }
    }
    // 尝试重新连接WebSocket
    function reconnectWebSocket() {
        if(flag)return;
        flag=true;
        var timer=setTimeout(function() {
            initSocket(); // 重新创建WebSocket连接
            flag=false;
        }, 5000); // 5秒后尝试重新连接
        store.commit('changeSocket',{label:'timer3',value:timer});
    }
    return ws;
}

/**
 * 
 * @param {*} msg //消息内容 
 * @param {*} flag //是否通知
 * @param {*} msgKey //消息标识       对应后端的 @WebSocketMsg 注解
 * @param {*} serverNames //发送消息的服务
 * @param {*} callbackFlag//回调标识
 *
 */
export function socketMsg(msg,flag,msgKey='',serverNames=[],callbackFlag=''){
    var params={
        data:msg,
        sendServiceMsg:flag,
        serverNames,
        msgKey,
        callbackFlag
    }
    console.log(params,'websocket')
    params=JSON.stringify(params);
    var ws=store.state.user.socketTimer.ws;
    if(ws){
        ws.send(params);
    }
}